import React from 'react';
import { Shield, ChevronRight } from 'lucide-react';

/**
 * Badhaka Card — shows house, badhakesh, and lord's current placement.
 * Click to open BadhakaPopup.
 */
export default function BadhakaCard({ badhaka, onClick }) {
  if (!badhaka) return null;
  const place = badhaka.badhakesh_placement || {};

  const typeLabel = badhaka.sign_type === 'movable' ? 'चर लग्न' : badhaka.sign_type === 'fixed' ? 'स्थिर लग्न' : 'द्विस्वभाव लग्न';

  return (
    <button
      onClick={onClick}
      data-testid="badhaka-card"
      className="w-full text-left rounded-2xl border border-rose-500/30 bg-gradient-to-br from-rose-950/40 via-purple-950/30 to-bg-primary p-5 shadow-xl hover:border-gold/40 transition-all"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Shield className="w-5 h-5 text-rose-300" />
          <h3 className="font-heading text-lg text-gold">बाधक विश्लेषण (Badhaka)</h3>
        </div>
        <ChevronRight className="w-4 h-4 text-text-muted" />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        <Cell label="लग्न प्रकार" value={typeLabel} />
        <Cell label="बाधक भाव" value={badhaka.house} highlight />
        <Cell label="बाधक राशि" value={badhaka.badhaka_sign_hi} />
        <Cell label="बाधकेश" value={badhaka.badhakesh_hi} highlight />
      </div>

      <div className="mt-3 grid grid-cols-2 md:grid-cols-4 gap-2">
        <Cell label="स्थित राशि" value={place.sign_hi || '—'} />
        <Cell label="भाव" value={place.house ?? '—'} />
        <Cell label="नक्षत्र" value={place.nakshatra || '—'} />
        <Cell label="पाद" value={place.pada ?? '—'} />
      </div>
    </button>
  );
}

const Cell = ({ label, value, highlight }) => (
  <div className={`rounded-lg px-3 py-2 border ${highlight ? 'bg-gold/10 border-gold/30' : 'bg-white/[0.03] border-white/10'}`}>
    <div className="text-[9px] uppercase tracking-wider text-text-muted">{label}</div>
    <div className={`text-sm mt-0.5 ${highlight ? 'text-gold font-semibold' : 'text-text-main'}`}>{value ?? '—'}</div>
  </div>
);
